















































































import Vue from "vue";
import dialog from "@/common/mixins/dialog";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import DelivertSetAttributeField from "../components/DeliverySetAttributeField.vue";
import { DeliveryModeAttributeMeta } from "../models/DeliveryModeAttributeMeta";
import { DeliveryShopSetAttributeForm } from "../forms/DeliveryShopSetAttributeForm";
import { Shop } from "../../shop/models/Shop";
export default Vue.extend({
  mixins: [dialog, pagination],
  components: {
    DelivertSetAttributeField
  },
  data() {
    const searchText = "";
    const isLoading = false;
    const isOpenDialog = false;
    const isDiaLogLoading = false;
    const deliveryModeAttributeMeta: DeliveryModeAttributeMeta[] = [];
    const deliveryShopSetAttributeForm: DeliveryShopSetAttributeForm = {};
    const shops: Shop[] = [];
    return {
      searchText,
      isLoading,
      isOpenDialog,
      isDiaLogLoading,
      deliveryModeAttributeMeta,
      deliveryShopSetAttributeForm,
      shops
    };
  },
  computed: {
    deliveryModeError() {
      return (this as any).$v.deliveryShopSetAttributeForm.deliveryMode.$error
        ? "Delivery Mode is required"
        : "";
    },
    shopError() {
      return (this as any).$v.deliveryShopSetAttributeForm.shop.$error
        ? "Shop is required"
        : "";
    }
  },
  async created() {
    this.isLoading = true;
    (this as any).getPaginationRouteQuery();
    if ((this as any).search) {
      this.searchText = (this as any).search;
    }
    await this.getShopsByDeliveryModeId();
    await this.getDeliveryAttributeByDeliveryId(+this.$route.params.id);
    this.isLoading = false;
  },
  watch: {
    async "$route.query"() {
      await this.getShopsByDeliveryModeId();
    }
  },
  methods: {
    async getShopsByDeliveryModeId() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage,
        search: this.searchText
      };
      try {
        const {
          data,
          meta
        } = await (this as any).$dep.deliveryModeUseCase.getShopByDeliveryId(
          +this.$route.params.id,
          form
        );

        this.shops = data;
        (this as any).setPaginationMeta(meta);
        (this as any).setSearchQuery(this.searchText);
      } catch (error) {
        console.log(error);
      }
    },
    async submit() {
      const isConfirmed = await (this as any).alertConfirm(
        "ยืนยันการใส่ค่า Attributes",
        "คุณต้องการเพิ่มข้อมูลหรือไม่ ?"
      );
      if (isConfirmed) {
        await this.createShopDeliveryAttribute();
      }
    },
    async createShopDeliveryAttribute() {
      try {
        await (this as any).$dep.deliveryModeUseCase.createDeliveryShopAttribute(
          this.deliveryShopSetAttributeForm
        );

        if (await (this as any).alertSuccess("Success", "อัพเดตข้อมูลสำเร็จ")) {
          this.isOpenDialog = false;
        }
      } catch (error) {
        this.isOpenDialog = false;
        console.log(error);
      }
    },
    async getDeliveryShopAttribute() {
      try {
        const {
          data
        } = await (this as any).$dep.deliveryModeUseCase.getDelivertShopAttributes(
          this.deliveryShopSetAttributeForm
        );
        if (data.jsonAttributes) {
          const currentAttributeValue: DeliveryModeAttributeMeta[] = (this as any).$dep.deliveryModeUseCase.mappingDeliveryShopAttributes(
            this.deliveryModeAttributeMeta,
            data.jsonAttributes
          );

          this.deliveryShopSetAttributeForm = {
            ...this.deliveryShopSetAttributeForm,
            attributes: currentAttributeValue
          };
        }
      } catch (error) {
        this.deliveryShopSetAttributeForm = {
          ...this.deliveryShopSetAttributeForm,
          attributes: this.deliveryModeAttributeMeta.map(
            (attribute: DeliveryModeAttributeMeta) => {
              return { ...attribute, value: "" };
            }
          )
        };
        console.log(error);
      }
    },
    goToDeliveryModeListPage() {
      this.$router.push({ name: "DeliveryModeListPage" });
    },
    async getDeliveryAttributeByDeliveryId(deliveryId: number) {
      try {
        const {
          data: attributes
        } = await (this as any).$dep.deliveryModeUseCase.getDeliveryAttributeByDeliveryId(
          deliveryId
        );

        this.deliveryModeAttributeMeta = attributes.map(
          (attribute: DeliveryModeAttributeMeta) => {
            return { ...attribute, value: "" };
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async openDialog(shop: Shop) {
      this.isLoading = true;

      this.deliveryShopSetAttributeForm = {
        deliveryId: +this.$route.params.id,
        shop,
        attributes: this.deliveryModeAttributeMeta
      };

      await this.getDeliveryShopAttribute();

      this.isLoading = false;
      this.isOpenDialog = true;
    },
    closeDialog() {
      this.isOpenDialog = false;
    }
  }
});
